import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CompareTray from "./CompareTray";
import ScrollToTop from "./ScrollToTop";
import PageViewTracker from "./PageViewTracker";

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <PageViewTracker />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CompareTray />
      <WhatsAppFloat />
    </div>
  );
};

export default Layout;
